import { GetterTree } from 'vuex';

import { ShareStateI } from './state';
import { RootStateI } from '../state';

export const getters: GetterTree<ShareStateI, RootStateI> = {
};
